<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit Vendor</mat-card-title>
    <mat-card-content>
      <form [formGroup]="editVendorForm" (ngSubmit)="editVendorForm.valid && saveVendor()">
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Vendor Name</mat-label>
              <input matInput formControlName="vendorName" placeholder="Vendor Name" maxlength="50" required
              appInputValidator [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" />
              <mat-error *ngIf="editVendorForm.get('vendorName').hasError('required')">
                Vendor Name is required.
              </mat-error>
              <mat-error *ngIf="editVendorForm.get('vendorName').hasError('maxlength')">
                Vendor Name cannot exceed 50 characters.
              </mat-error>
                <mat-error *ngIf="editVendorForm.get('vendorName').hasError('noAlphabet')">
                  Vendor Name must contain at least one alphabet character.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Description</mat-label>
              <input matInput formControlName="description" placeholder="Description" maxlength="100" required
               appInputValidator [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" />
              <mat-error *ngIf="editVendorForm.get('description').hasError('required')">
                Description is required.
              </mat-error>
              <mat-error *ngIf="editVendorForm.get('description').hasError('maxlength')">
                Description cannot exceed 100 characters.
              </mat-error>
                <mat-error *ngIf="editVendorForm.get('description').hasError('noAlphabet')">
                  Description must contain at least one alphabet character.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput formControlName="address" placeholder="Address" maxlength="250" required
               appInputValidator [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" />
              <mat-error *ngIf="editVendorForm.get('address').hasError('required')">
                Address is required.
              </mat-error>
              <mat-error *ngIf="editVendorForm.get('address').hasError('maxlength')">
                Address cannot exceed 250 characters.
              </mat-error>
               <mat-error *ngIf="editVendorForm.get('address').hasError('noAlphabet')">
                  Address must contain at least one alphabet character.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>EmailIds</mat-label>
              <input matInput formControlName="emailIds" placeholder="Emails (e.g., aa@abc.com; bb@xyz.com)" maxlength="100" required>
              <mat-error *ngIf="editVendorForm.get('emailIds').hasError('required')">
                EmailIds are required.
              </mat-error>
              <mat-error *ngIf="editVendorForm.get('emailIds').hasError('invalidEmailIds')">
                Enter valid emails, separated by semicolons.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Contact Numbers</mat-label>
              <input matInput formControlName="contactNumbers" placeholder="Numbers (e.g., 1234567890; 0987654321)" maxlength="100" required>
              <mat-error *ngIf="editVendorForm.get('contactNumbers').hasError('required')">
                Contact Numbers are required.
              </mat-error>
              <mat-error *ngIf="editVendorForm.get('contactNumbers').hasError('invalidContactNumbers')">
                Enter 10-digit numbers, separated by semicolons.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="col-md-4">
         
        </div>
        <div class="col-md-4">
          <button md-raised-button type="button" class="btn btn-rose" (click)="close()">Close</button>
          <button md-raised-button type="button" class="btn btn-rose" [disabled]="!editVendorForm.valid" (click)="saveVendor()">Update</button>
        </div>
        <div class="col-md-4"></div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
